import Box from "@mui/material/Box";
import { Component } from "react";
import ProfileHeader from "../../../components/ProfileHeader";
import RecoverPasswordForm from "../../public/recoverPassword/recoverPasswordThird/form/RecoverPasswordForm";

type Props = {};

type State = {
}

export default class ChangePassword extends Component<Props, State> {

  componentDidMount() {
    document.body.classList.add("grey-background");
  }

  componentWillUnmount() {
    window.location.reload();
    document.body.classList.remove("grey-background");
  }

  render() {
    return (
      <Box>
        <ProfileHeader title='Nueva contraseña' selectedOptionIndex={1}></ProfileHeader>
        <RecoverPasswordForm submitButtonRedirect='/change-password/changed' submitButtonText='Guardar' cancelButtonRedirect="/" labelNewPasswordText="Ingrese una nueva contraseña" passwordKey="proveKey" email="MailEjemplo@gmail.com" isChangePassword={true}></RecoverPasswordForm>
      </Box>
    );
  }

}